import React from "react";
import { useTranslation } from "react-i18next";
import arrow from "../../assets/common/arrow-down.svg";

const Select = ({
  label,
  labelClassName,
  error,
  options = [],
  className,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 relative w-[220px]">
      <label className={`block mb-2 font-medium ${labelClassName}`}>
        {label}
      </label>
      <div className="relative w-[150px] lg:w-full">
        <select
          className={`w-full h-[30px] lg:h-[40px] pl-4 pr-10 rounded-lg bg-secondary text-white text-sm lg:text-lg appearance-none transition-colors cursor-pointer focus:outline-none focus:ring-0 border-0 ${className}`}
          {...props}
        >
          <option value="" disabled hidden>
            {t("button.selectOption")}
          </option>
          {options.map((opt, idx) => (
            <option
              key={opt.value}
              value={opt.value}
              className="text-primary bg-white text-center text-lg border-b border-primary"
            >
              {opt.label}
            </option>
          ))}
        </select>
        {/* Custom arrow */}
        <span className="pointer-events-none absolute top-1/2 right-4 transform -translate-y-1/2 text-white text-lg">
          <img src={arrow} alt="Logo" className="" />
        </span>
      </div>
      {error && <p className="mt-1 text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default Select;
